import createStore from './createStore';
export default createStore();
